import { render } from "./BackendHealthCard.vue?vue&type=template&id=26dfc593&scoped=true"
import script from "./BackendHealthCard.vue?vue&type=script&lang=js"
export * from "./BackendHealthCard.vue?vue&type=script&lang=js"

import "./BackendHealthCard.vue?vue&type=style&index=0&id=26dfc593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dfc593"]])

export default __exports__